import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';
import {noop} from 'lodash';

import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';
import {createPopoverProvider} from '/provider/PopoverProvider';
import {generateComponentCallback} from '/util/component.util';

import {CreateCandidateProfileScreen} from './CreateCandidateProfileScreen';

interface CreateCandidateProfileProps {
  onClose: () => void;
  credentialsEmail: string;
  saveCandidateProfile: (() => void) | null;
  userId: number;
  recordId: number;
  lastPaidRank: string;
}

export const CreateCandidateProfile: React.FC<CreateCandidateProfileProps> = ({
  onClose = noop,
  credentialsEmail = '',
  saveCandidateProfile = null,
  userId = 0,
  lastPaidRank,
}) => {
  const popoverProvider = createPopoverProvider();
  const {Provider: PopoverProvider} = popoverProvider;

  const getMainScreenComponent = () => {
    const {Consumer: PopoverConsumer} = popoverProvider;
    return () => {
      return (
        <PopoverConsumer>
          {({popoverShow}) => {
            return (
              <CreateCandidateProfileScreen
                onClose={onClose}
                popoverShow={popoverShow}
                credentialsEmail={credentialsEmail}
                saveCandidateProfile={saveCandidateProfile}
                userId={userId}
                lastPaidRank={lastPaidRank}
              />
            );
          }}
        </PopoverConsumer>
      );
    };
  };

  const getCandidateProfileStackComponent = () => {
    const ProfileStackNavigator = createStackNavigator();
    const MainScreen = getMainScreenComponent();

    return generateComponentCallback({
      component: (
        <ProfileStackNavigator.Navigator
          initialRouteName="createcandidate-profile-main-screen"
          screenOptions={{headerShown: false}}>
          <ProfileStackNavigator.Screen
            name="createcandidate-profile-main-screen"
            component={MainScreen}
          />
        </ProfileStackNavigator.Navigator>
      ),
    });
  };

  const ProfileStack = getCandidateProfileStackComponent();

  return (
    <PopoverProvider>
      <KeyboardAvoidingView>
        <ProfileStack />
      </KeyboardAvoidingView>
    </PopoverProvider>
  );
};

export default CreateCandidateProfile;
